export default "__VITE_PUBLIC_ASSET__9f140b74__"